/** Detect OIDC error callbacks so the app does not automatically restart login. */
export function hasAuthorizationError(search: string, hash: string): boolean {
  const query = new URLSearchParams(search);
  const fragment = new URLSearchParams(hash.startsWith('#') ? hash.slice(1) : hash);
  return query.has('error') || fragment.has('error');
}
